import Vue from 'vue';
import Vuex from 'vuex';
import { postLoginOrRegist, getUserInfo } from '@/api/login';
import { getDeviceInfo } from '@/utils/index';
import doTrack from '@/utils/pointLog';
import Cookies from 'js-cookie';
import { cacheTrackGlobal } from '@/utils/common';
import { extractTargetDomain } from '@/utils/index';

Vue.use(Vuex);

const userStateObj = {
	isGetting: false,
	resolveFns: [],
};

export default new Vuex.Store({
	state: {
		token: '',
		userInfo: {},
		queryInfo: {},
		isSnapshotuser: null,
	},
	getters: {
		userInfo(state) {
			return { ...state.userInfo };
		},
	},
	mutations: {
		changeIsSnapshotuser(state, data) {
			state.isSnapshotuser = data;
		},
		setToken(state, data) {
			if (data) {
				state.token = data;
			}
		},
		setQueryInfo(state, data) {
			if (data && Object.prototype.toString(data) === '[object Object]') {
				Object.assign(state.queryInfo, data);
			}
		},
		setUserInfo(state, data) {
			Object.assign(state.userInfo, {
				...data,
			});
		},
	},
	actions: {
		getUserInfo({ commit, state, dispatch }, unionid) {
			const userInfo = state.userInfo;
			return new Promise((resolve, reject) => {
				if (userStateObj.isGetting) {
					userStateObj.resolveFns.push(resolve);
					return;
				} else {
					userStateObj.isGetting = true;
				}
				const selfGetUserInfo = () => {
					// 获取信息
					getUserInfo()
						.then(res => {
							commit('setUserInfo', res);
							// 遗留的埋点
							cacheTrackGlobal.done();
							userStateObj.isGetting = false;
							resolve(res);
							// 回调逻辑
							if (userStateObj.resolveFns.length) {
								userStateObj.resolveFns.forEach(fn => {
									fn(res);
								});
								userStateObj.resolveFns = [];
							}
						})
						.catch(err => {
							reject(err);
						});
				};
				if (unionid) {
					// 只有wxlogin组件会走一次，每次网页这里只会走一次
					// 更新信息，并获取token
					const devcieInfo = getDeviceInfo();
					postLoginOrRegist({
						unionid: unionid,
						deviceOs: devcieInfo.model,
						status: 1,
						avatarAddress: userInfo.headimgurl,
						openid: userInfo.openid,
						phone: '',
						studentName: userInfo.nickname,
						deviceCode: '',
						enrollIp: '',
						promotionId: state.queryInfo.promotionId ? state.queryInfo.promotionId : null,
					}).then(res => {
						const domain = extractTargetDomain(location.href);
						Cookies.set('h5token', res, {
							expires: 365, // 天
							domain: domain,
						});
						commit('setToken', {
							token: res,
						});
						selfGetUserInfo();
						// 登录埋点
						doTrack({ type: 'login' });
					});
				} else {
					selfGetUserInfo();
				}
			});
		},
	},
	modules: {},
});
